import { pickLocale, type MultiQuantityCharacteristic } from '../../schema';
import { useCharacteristicSelection, useStoreActions } from '../../state/StoreContext';
import { useTranslation } from '../../i18n';

interface MultiQuantityViewProps {
    characteristic: MultiQuantityCharacteristic;
    locale: string | undefined;
}

/**
 * MultiQuantity: a quantity input per Value. Phase 2a: live-editable.
 */
export function MultiQuantityView({ characteristic, locale }: MultiQuantityViewProps) {
    const { t } = useTranslation();
    const selection = useCharacteristicSelection(characteristic.id);
    const { setQuantity } = useStoreActions();
    const quantities = selection?.kind === 'quantities' ? selection.quantities : {};

    if (characteristic.values.length === 0) {
        return <p className="cfg-group__empty">{t('characteristic.no_options')}</p>;
    }

    return (
        <div>
            {characteristic.values.map((value) => {
                const label = pickLocale(value.title, locale) ?? value.value ?? `#${value.id}`;
                const current = quantities[value.id] ?? 0;
                return (
                    <div key={value.id} className="cfg-quantity-row">
                        <span className="cfg-quantity-row__label">{label}</span>
                        <input
                            type="number"
                            className="cfg-input cfg-quantity-row__input"
                            value={current}
                            min={0}
                            onChange={(e) => {
                                const n = Number(e.target.value);
                                setQuantity(
                                    characteristic.id,
                                    value.id,
                                    Number.isFinite(n) && n >= 0 ? n : 0,
                                );
                            }}
                            aria-label={t('characteristic.aria_quantity', { label })}
                        />
                    </div>
                );
            })}
        </div>
    );
}
